<template>
  <v-alert no-gutters class="c-custom--v-alert c-custom--h-100 pa-0">
    <div class="c-result-top-infos__col--green c-result-top-infos__col--radius result-clover-point c-custom--h-100 mb-0">
      <v-row
        no-gutters
        class="align-center c-custom--h-100"
      >
        <v-col
          cols="12" sm="12" md="6"
          class="pr-md-3"
        >
          <p class="c-result-title-size result-clover-point__title pb-3 font-weight-bold">
            継続ボーナス！
          </p>
          <v-row
            no-gutters
            class="result-clover-point__row">
            <v-col v-for="(history) of continueBonusHistorys" :key="history.index" class="result-clover-point__row-bonus">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <img v-if="history.continue_status===1" src="@/assets/continueBonus/cloverOn.png" width="28px" v-bind="attrs" v-on="on">
                  <img v-else src="@/assets/continueBonus/cloverOff.png" width="28px" v-bind="attrs" v-on="on">
                </template>
                <span>{{history.start}} ～ {{history.end}}</span>
              </v-tooltip>
            </v-col>
          </v-row>
        </v-col>
        <v-col
          cols="12" sm="12" md="6"
          class="text-md-left text-center"
          >
          <div v-if="campaignUser.course.length > 0">
            <v-btn
              @click="showBonusInfoDialog = true"
              elevation="0"
              color="white"
              class="result-clover-point__subtitle pa-0 font-weight-bold"
            >
              継続ボーナススタンプとは？
            </v-btn>
            <p v-if="!isMobile">
              {{continueBonus.per_day}}日に1度以上記録・保存して、クローバーマークを貯めましょう！<br/>
              {{continueBonus.incentive_requirement}}個以上貯めると、達成した時の賞品が＋100円になります！
            </p>
          </div>

          <!-- 継続ボーナススタンプとは？のダイアログ -->
          <v-dialog
            v-model="showBonusInfoDialog"
            scrollable
            :max-width="350"
            class="c-custom--v-dialog"
          >
            <v-card
              outlined
            >
              <v-btn
                fab
                small
                elevation="0"
                @click="showBonusInfoDialog = false"
                class="c-result-dialog-close-btn"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
              <div class="c-result-dialog-card">
                <p class="ma-0 pb-3 font-weight-bold">
                  継続ボーナススタンプとは？
                </p>
                {{continueBonus.per_day}}日に1度以上記録・保存して、クローバーマークを貯めましょう！<br/>
                {{continueBonus.incentive_requirement}}個以上貯めると、達成した時の賞品が＋100円になります！
              </div>
            </v-card>
          </v-dialog>
        </v-col>
      </v-row>
    </div>
  </v-alert>
</template>

<script>
export default {
  name: 'ResultContinueBonus',
  data () {
    return {
      dailyImageList: [],
      participants: '',
      myRank: '',
      isCampaignPeriod: false,
      showAppStatusInfo: false,
      showBonusInfoDialog: false // 継続ボーナススタンプとは？のダイアログ
    }
  },
  props: ['campaignUser'],
  components: {
  },
  computed: {
    campaign () {
      return this.$store.getters.getCampaign
    },
    continueBonusHistorys () {
      return this.$store.getters.getContinueBonusHistorys
    },
    continueBonus () {
      return this.$store.getters.getContinueBonus
    },
    isMobile () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return true
        case 'sm': return true
        case 'md': return false
        case 'lg': return false
        case 'xl': return false
      }
      return false
    }
  },
  async created () {
    if (!this.campaign.id) {
      await this.$store.dispatch('initCampaign')
    }
    await this.$store.dispatch('setContinueBonusProcessorOutput', { campaignId: this.campaign.id, type: 'read' })
  }
}
</script>

<style scoped lang="scss">
.result-clover-point {
  font-size: 15px;

  p {
    margin: 0;
  }

  .result-clover-point__title {
    color: #3DCEBB;
  }
  .result-clover-point__subtitle {
    text-decoration: underline;
    letter-spacing: 0;
  }
  .result-clover-point__row {
    .result-clover-point__row-bonus {
      max-width:28px !important;
      min-width:28px !important;
      margin: 0 3px;
      padding:0;
    }
  }
}
</style>
